<template>
  <BaseDataIterator
    ref="contactRequestList"
    :service="fetchContactRequests"
    :filter-options="filterOptions"
    :save-query-action="saveQueryAction"
    :load-queries-action="loadQueriesAction"
    :export-action="exportContactRequests"
    :options="{
      disableCreateAudienceOption: true,
      exportFilename: 'contact_requests',
    }"
  >
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #header>
          <ContactRequestListHeader />
        </template>

        <template #default="dataTableProps">
          <ContactRequestListItem
            :key="dataTableProps.item.id"
            :contact-request="dataTableProps.item"
            @contact-request-deleted="dataIteratorProps.fetchList"
            @contact-request-updated="dataIteratorProps.fetchList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import {
  accountContactRequestsClient,
  accountContactRequestSavedQueriesClient,
} from '@/api/clients';
import getFilterOptions from './filterOptions';
import ContactRequestListHeader from './ContactRequestListHeader.vue';
import ContactRequestListItem from './ContactRequestListItem.vue';

export default {
  components: {
    ContactRequestListHeader,
    ContactRequestListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filterOptions: getFilterOptions(this.accountId),
    };
  },
  watch: {
    '$route.query': {
      handler() {
        const { execute } = this.$refs?.contactRequestList?.$refs?.baseQueryComponent || {};

        if (typeof execute !== 'function') {
          return;
        }

        execute();
      },
    },
  },
  methods: {
    saveQueryAction(data) {
      return accountContactRequestSavedQueriesClient.store(this.accountId, data);
    },
    loadQueriesAction() {
      return accountContactRequestSavedQueriesClient.list(this.accountId);
    },
    async fetchContactRequests(params = {}) {
      try {
        const response = await accountContactRequestsClient.list(this.accountId, {
          ...params,
          include: 'pipelineStage,user',
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async exportContactRequests(query = {}) {
      try {
        const response = await accountContactRequestsClient.list(
          this.accountId,
          {
            ...query,
            export: true,
          },
          {
            responseType: 'blob',
          }
        );

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
